import * as AriaKit from '@ariakit/react'

/**
 * Hook which provides state to tooltips
 */
export function useTooltipState({ showTimeout = 0, hideTimeout = 0, ...settings }: AriaKit.TooltipStoreProps = {}) {
  return AriaKit.useTooltipStore({
    ...settings,
    showTimeout,
    hideTimeout,
  })
}

export type TooltipSettingsPropType = ReturnType<typeof useTooltipState>
